
"use client";
import React, { useEffect, useState, useContext } from "react";
import { MdDelete } from "react-icons/md";
import ComboBox from "../DropDown/DropDown";
import { addCards, deleteCard, editCard, getCardDetails, getAiRecommendations, Checkbox, Checkedbox } from "../api/Service";
import moment from 'moment/moment';
import SideBar from "../SideBar/sideBar";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LockIcon from '@mui/icons-material/Lock';
import { useNavigate } from "react-router-dom";
import { ActiveContext } from '../../Context/Context';
import { ActivePlan } from "../api/Service";
import '../../index.css';


function Utilization() {
  const [cards, setcardData] = useState([])
  const [active, setActive] = useState('')
  const [isCardVisible, setIsCardVisible] = useState(false);
  const [isChecked, setIsChecked] = useState(0)
  //const [utilizationPercentage, setUtilizationPercentage] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate()
  const today = new Date();
  const formattedDate = today.toISOString().split('T')[0];
  //const active = useContext(ActiveContext)
  const [addCard, setAddCard] = useState({
    card_type: "visa",
    card_limit: 0,
    balance: 0,
    due_date: formattedDate,
    closing_date: formattedDate,

  })
  const FirstName = localStorage.getItem('firstName') || '';
  const LastName = localStorage.getItem('lastName') || '';
  const checkValue = localStorage.getItem('checkBox');
  const initials = `${FirstName.charAt(0)}${LastName.charAt(0)}`


  const ActiveApi = async () => {
    const res = await ActivePlan()

    setActive(res.data.data.PlanTypeName)
  }
  useEffect(() => {
    ActiveApi()
    setLoading(false)
  })

  const resetAddCard = () => {
    setAddCard({
      card_type: "visa",
      card_limit: 0,
      balance: 0,
      due_date: "2024-09-04",
      closing_date: "2024-09-23",

    })
  }

  const toggleCardVisibility = () => {
    if (cards.length === 100) {
      navigate('/app/subscription')
    }
    setIsCardVisible(prevState => !prevState);

  };
  const notifySuccess = (message) => {
    toast.success(message, {
      autoClose: 3000,
      style: {
        background: "#90EE90",
        color: "#000",
        fontWeight: "bold",
        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
        borderRadius: "4px",
      }
    })
  }
  const notifyError = (message) => {
    toast.error(message || "An error occurred. Please try again.", {
      autoClose: 5000,
      style: {
        background: "#FF7F7F",
        color: "black",
        fontWeight: "bold",
        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
        borderRadius: "4px",
      },
    });
  };

  const handleCheckbox = async (e) => {
    const checked = e.target.checked;
    setIsChecked(checked);
    let value = checked ? 1 : 0
    localStorage.setItem('checkBox', value)
    const valueToSend =
    {
      acceptAlert: value
    }
    try {
      const res = await Checkedbox(valueToSend)
      if (res.ok) {
        console.log('API call successful, sent:', valueToSend);

      } else {
        console.error('API call failed');
      }


    } catch (err) {
      console.log(err)
    }

  }

  const handleSubmit1 = async (data) => {
    setLoading(true);
    try {
      //notifySuccess("Card Updated Successfully")
      cards.filter(id => {

        if (data === id.id) {
          const data =
          {
            id: id.id,
            balance: id.balance,
            card_limit: id.card_limit,
            card_type: id.card_type,
            closing_date: moment(id.closing_date).format('YYYY-MM-DD'),
            due_date: moment(id.due_date).format('YYYY-MM-DD')

          }
          const response = editCard(data);
          if (response) {
            //handleSubmit2()
          }
        }
      })
    }
    catch (error) {
      notifyError(error)
      console.error('Error fetching :', error);
    } finally {
      setLoading(false);
    }
  };


  const handleSubmit2 = async () => {
    setLoading(true);
    try {
      const response = await getCardDetails();

      setcardData(response.data.data)
      //setUtilizationPercentage(response.data.utilization_percentage)
      setIsCardVisible(false)
    }
    catch (error) {
      notifyError(error)
      console.error('Error fetching :', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (checkValue === '1') {
      //console.log(checkValue,"----",isChecked)
      setIsChecked(1)
    }
    handleSubmit2()
  }, [])

  const onCardUpdate = (data) => {

    setcardData(data)

  }

  const onCardDelete = async (id) => {
    try {
      const data = {
        id: id
      }
      notifySuccess("Card Deleted successfully")
      const response = await deleteCard(data);
      handleSubmit2()
    } catch (error) {
      notifyError(error)
      console.error('Error deleting card:', error);
    }
  };

  const handleAddCard = (field, value) => {
    setAddCard(prevState => ({
      ...prevState,
      [field]: value
    }));
    //handleSubmit1()
    //handleSubmit2

  };


  const [aiRecommendations, setAiRecommendations] = React.useState(null);
  const [loadingAi, setLoadingAi] = React.useState(null);
  const [recommendations, setRecommendations] = React.useState([]);

  const calculateTotalBalance = () => {
    return cards.reduce((total, card) => total + card.balance, 0);
  };

  const calculateUtilization = () => {
    const { totalBalance, totalLimit } = cards.reduce(
      (totals, card) => {
        const cardLimit = Number(card.card_limit);
        const balance = Number(card.balance);

        if (cardLimit > 0) {
          totals.totalBalance += balance;
          totals.totalLimit += cardLimit;
        }
        return totals;
      },
      { totalBalance: 0, totalLimit: 0 } // Initial values
    );

    // Avoid division by zero and calculate the utilization percentage
    return totalLimit > 0 ? (totalBalance / totalLimit) * 100 : 0;
  };

  // const calculateUtilization = () => {
  //   console.log(cards)
  //   return cards.reduce(calulateTest, 0)
  // };

  const handleCardUpdate = (index, field, value) => {

    const updatedCards = [...cards];
    updatedCards[index][field] = value;
    onCardUpdate(updatedCards);

    setAiRecommendations(null);
    handleSubmit1(updatedCards[index]['id'])
  };

  const handleCardDelete = (index) => {
    const updatedCards = cards.filter((_, i) => i !== index);
    onCardDelete(updatedCards);
    setAiRecommendations(null);
  };

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return `${d.toLocaleString("default", {
      month: "long",
    })} - ${d.getDate()} - ${d.getFullYear()}`;
  };

  const getAiRecommendationsFromClaude = async () => {
    if (active === "Free") {
      navigate('/app/subscription')
    }
    else {
      try {
        setLoadingAi(true)
        const response = await getAiRecommendations(cards);

        //const data = await response.json();
        setAiRecommendations(true);
        setRecommendations(response);
        setLoadingAi(false)
      } catch (error) {
        notifyError("Error getting AI recommendations")
        console.error("Error getting AI recommendations:", error);
      }
    }

  };

  const handleDateChange = (index, field, value) => {

    const [year, month, day] = value.split("-");
    const formattedMonth = (month && typeof month === 'string') ? month.padStart(2, "0") : "00";
    const formattedDay = (day && typeof day === 'string') ? day.padStart(2, "0") : "00";
    const formattedDate = `${year}-${formattedMonth}-${formattedDay}`;
    handleCardUpdate(index, field, formattedDate);
  };

  const handleCardTypeChange = (index, selectedPerson) => {
    if (selectedPerson && selectedPerson.name) {
      handleCardUpdate(index, "card_type", selectedPerson.name);
    } else {
      console.error('selectedPerson is undefined or does not have a name property');
    }
  };


  const createNewCard = async () => {
    if (active === "Free" && cards.length === 2) {
      navigate('/app/subscription')
    } else {
      try {

        const response = await addCards(addCard);
        notifySuccess("Card Added Successfully")
        handleSubmit2()
        resetAddCard()

      }
      catch (error) {
        console.error('Error fetching :', error);
      }
    }
  }
  //console.log(checkValue,'djkebhe')




  return (

    <div className="flex h-100% bg-[#121212] text-white">
      <SideBar />

      <main className="flex-1 overflow-y-auto p-6">
      <div className="flex flex-col md:flex-row justify-between items-center mt-5 mb-4">
                    <h1 className="text-2xl md:text-3xl font-bold text-white">Card Utilization</h1>
                    <div className="ml-0 md:ml-[30.75rem] mt-4 md:mt-0">
                        {active?.includes('Lifetime Access') && (
                            <h1 className="text-white font-semibold">You Have Lifetime Access</h1>
                        )}
                    </div>
                    <div className="w-10 h-10 bg-purple-500 rounded-full flex items-center justify-center mt-4 md:mt-0">
                        <span className="text-white font-bold">{initials}</span>
                    </div>
                </div>
        {/* <div className="flex justify-between items-center mt-5 mb-8">
          <h1 className=" text-3xl font-bold">Card Utilization</h1>
          <div className="flex items-center space-x-4">
            {/* <i className="fas fa-comments text-gray-400 text-xl"></i>
            <i className="fas fa-bell text-gray-400 text-xl"></i> */}
            {/* {active?.includes('Lifetime Access') && <h1 className="text-white font-semibold">You Have Lifetime Access</h1>} */}
            {/* <div className="w-10 h-10 bg-purple-500 rounded-full flex items-center justify-center">
              <span className="text-white font-bold">{initials}</span>
            </div>
          </div>
        </div>  */}
        <div className="videoyou bg-[#1E1E1E] sm:p-4 sm:p-6 rounded-lg mx-auto mb-8" style={{ "height": "500px", "maxWidth": "850px" }}>
          <div className="relative h-full">
            <iframe
              width="100%"
              height="100%"
              src="https://player.vimeo.com/video/1021516118"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="Video"
              className="absolute inset-0 rounded-lg"
            ></iframe>
          </div>


        </div>

        <div className=" fbg-gray-800 shadow-lg rounded-lg p-6 mb-8 bg-[#1E1E1E]">
          <div>

            <div>
              <h2 className="text-2xl font-semibold mb-4">
                Your Credit Card Limits
              </h2>
            </div>
            <div>

              {cards.map((card, index) => (
                <div key={index} className="mb-6 border-b border-gray-700 pb-4">
                  <div className="flex justify-between  items-center mb-2">
                    <div className="flex justify-between w-full items-center ">

                      <div className=" flex items-center justify-between">
                        <ComboBox
                          value={card.card_type}
                          onChange={(selectedPerson) => handleCardTypeChange(index, selectedPerson)}
                        />
                      </div>
                      <button onClick={() => { onCardDelete(card.id) }} className="flex items-center text-red-600"><MdDelete className=" h-6 w-6" />Delete</button>
                    </div>
                    <button
                      onClick={() => handleCardDelete(index)}
                      className="text-red-500 hover:text-red-700"
                    >
                      {/* <i className="fas fa-trash"></i> */}
                    </button>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <div className=" flex justify-between items-center">
                        <label className="block text-sm font-medium text-gray-400">
                          Limit
                        </label>

                      </div>
                      <div className="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="number"
                          value={card.card_limit}
                          onChange={(e) =>
                            handleCardUpdate(index, "card_limit", Number(e.target.value))
                          }
                          className="bg-gray-700 focus:ring-purple-500 focus:border-purple-500 block w-full pb-2 pt-2 pl-3 pr-3 sm:text-sm border-gray-600 rounded-md"
                        />

                      </div>
                    </div>
                    <div>
                      <div className=" flex justify-between items-center">
                        <label className="block text-sm font-medium text-gray-400">
                          Balance
                        </label>

                      </div>
                      <div className="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="number"
                          value={card.balance}
                          onChange={(e) =>
                            handleCardUpdate(
                              index,
                              "balance",
                              Number(e.target.value)
                            )
                          }
                          className="bg-gray-700 focus:ring-purple-500 focus:border-purple-500 block w-full pb-2 pt-2 pl-3 pr-3 sm:text-sm border-gray-600 rounded-md"
                        />

                      </div>
                    </div>
                    <div>
                      <div className=" flex justify-between items-center">
                        <label className="block text-sm font-medium text-gray-400">
                          Payment Due Date
                        </label>
                      </div>
                      <div className="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="date"
                          value={moment(card.due_date).format('YYYY-MM-DD')}
                          onChange={(e) =>
                            handleDateChange(
                              index,
                              "due_date",
                              e.target.value
                            )
                          }
                          className="bg-gray-700 focus:ring-purple-500 focus:border-purple-500 block w-full pb-2 pt-2 pl-3 pr-3 sm:text-sm border-gray-600 rounded-md"
                        />

                      </div>
                    </div>
                    <div>
                      <div className=" flex justify-between items-center">
                        <label className="block text-sm font-medium text-gray-400">
                          Statement Closing Date
                        </label>

                      </div>
                      <div className="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="date"
                          value={moment(card.closing_date).format('YYYY-MM-DD')}
                          onChange={(e) =>
                            handleDateChange(
                              index,
                              "closing_date",
                              e.target.value
                            )
                          }
                          className="bg-gray-700 focus:ring-purple-500 focus:border-purple-500 block w-full pb-2 pt-2 pl-3 pr-3 sm:text-sm border-gray-600 rounded-md"
                        />

                      </div>
                    </div>


                  </div>
                  {/* <div className="pt-4 flex justify-end items-end">
                    <button onClick={() => handleSubmit1(card.id)} className="pt-1 pl-4 pr-4 pb-1 rounded-md bg-red-600 text-white" disabled={loading}>{loading ? "...loading" : "Edit"}</button>
                  </div> */}
                </div>
              ))}

              <div>

                <button
                  className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded"
                  onClick={() => createNewCard()}
                >
                  Add Card
                </button>

                {isCardVisible && (
                  <div className="mb-6 border-b border-gray-700 pb-4">
                    <div className="flex justify-between items-center mb-2">
                      <div className="flex justify-between w-full items-center">
                        <div className="flex items-center justify-between">
                          <ComboBox
                            value="Visa"
                            onChange={(selectedCard) => handleAddCard('card_type', selectedCard.name)}
                          />

                        </div>
                        {/* <button onClick={() => { onCardDelete() }} className="flex items-center text-red-600"><MdDelete className=" h-6 w-6" />Delete</button> */}

                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <div className="flex justify-between items-center">
                          <label className="block text-sm font-medium text-gray-400">
                            Limit
                          </label>
                        </div>
                        <div className="mt-1 relative rounded-md shadow-sm">
                          <input
                            type="number"
                            value={addCard.card_limit}
                            onChange={(e) => {
                              const value = Number(e.target.value);
                              handleAddCard("card_limit", value);
                              ;
                            }}
                            className="bg-gray-700 focus:ring-purple-500 focus:border-purple-500 block w-full pb-2 pt-2 pl-3 pr-3 sm:text-sm border-gray-600 rounded-md"
                          />
                        </div>
                      </div>

                      <div>
                        <div className="flex justify-between items-center">
                          <label className="block text-sm font-medium text-gray-400">
                            Balance
                          </label>
                        </div>
                        <div className="mt-1 relative rounded-md shadow-sm">
                          <input
                            type="number"
                            value={addCard.balance}
                            onChange={(e) => {
                              const value = Number(e.target.value);
                              handleAddCard("balance", value);

                            }}
                            className="bg-gray-700 focus:ring-purple-500 focus:border-purple-500 block w-full pb-2 pt-2 pl-3 pr-3 sm:text-sm border-gray-600 rounded-md"
                          />
                        </div>
                      </div>

                      <div>
                        <div className="flex justify-between items-center">
                          <label className="block text-sm font-medium text-gray-400">
                            Payment Due Date
                          </label>
                        </div>
                        <div className="mt-1 relative rounded-md shadow-sm">
                          <input
                            type="date"
                            // value={new Date(addCard.due_date).toISOString().split('T')[0]}
                            value={moment(addCard.due_date).format('YYYY-MM-DD')}
                            onChange={(e) => {
                              const value = e.target.value
                              handleAddCard("due_date", value);

                            }}
                            className="bg-gray-700 focus:ring-purple-500 focus:border-purple-500 block w-full pb-2 pt-2 pl-3 pr-3 sm:text-sm border-gray-600 rounded-md"
                          />
                        </div>
                      </div>

                      <div>
                        <div className="flex justify-between items-center">
                          <label className="block text-sm font-medium text-gray-400">
                            Statement Closing Date
                          </label>
                        </div>
                        <div className="mt-1 relative rounded-md shadow-sm">
                          <input
                            type="date"
                            value={moment(addCard.closing_date).format('YYYY-MM-DD')}
                            onChange={(e) => {
                              const value = e.target.value
                              handleAddCard("closing_date", value);
                            }}
                            className="bg-gray-700 focus:ring-purple-500 focus:border-purple-500 block w-full pb-2 pt-2 pl-3 pr-3 sm:text-sm border-gray-600 rounded-md"
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className="pt-4 flex justify-end items-end">
                      <button onClick={() => createNewCard()} className="pt-1 pl-4 pr-4 pb-1 rounded-md bg-red-600 text-white" >Add Card</button>
                    </div> */}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="mt-4">
            <p className="text-lg">
              Total Credit Card Balance: ${calculateTotalBalance().toFixed(2)}
            </p>
            <p className="text-lg">
              Credit Utilization:
              <span
                className={
                  calculateUtilization() < 5 ? "text-green-500" : "text-red-500"}
              >
                {calculateUtilization().toFixed(2)}%
              </span>
            </p>

            {(() => {
              if (calculateUtilization() >= 5) {
                return (
                  <p className="text-red-500 mt-2">
                    Alert: Your credit utilization is over 5%. Consider making a payment to bring it below 5%.
                  </p>
                );
              } else {
                return (
                  <p className="text-green-400 mt-2">
                    Alert: Great!!!! Your credit utilization is under 5%.
                  </p>
                );

                return null;
              }
            })()}


          </div>
        </div>

        <div className="bg-gray-800 shadow-lg rounded-lg p-4 sm:p-6">
          <div className="flex flex-col sm:flex-row justify-between items-center mb-4">
            <h2 className="text-xl sm:text-2xl font-semibold text-center sm:text-left">AI Recommendations</h2>
            {active === 'Free' ? (<></>) : (<div className="checkbox-wrapper flex content-end">
              <label>
                <input type="checkbox" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" checked={isChecked} onChange={handleCheckbox} />
                <span className="p-3 font-semibold">Send Alert Messages</span>
              </label>
            </div>)}

            <div className="mt-4 sm:mt-0">

              {active === "Free" ? (
                <button
                  onClick={() => getAiRecommendationsFromClaude()}
                  className="flex items-center bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded text-sm sm:text-base"
                >
                  {loadingAi ? 'Loading...' : 'Get Recommendations'}
                  <LockIcon className="ml-2 sm:ml-5" />
                </button>
              ) : (
                <button
                  onClick={() => getAiRecommendationsFromClaude()}
                  className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded text-sm sm:text-base"
                >
                  {loadingAi ? 'Loading...' : 'Get Recommendations'}
                </button>
              )}
            </div>
          </div>

          {aiRecommendations ? (
            <div className="space-y-4">
              {recommendations.length && recommendations.map((card, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-r from-purple-900 to-indigo-900 p-3 sm:p-4 rounded-lg shadow"
                >
                  <h3 className="text-lg sm:text-xl font-semibold mb-2 text-purple-300">{card.cardName}</h3>
                  <div className="space-y-1 sm:space-y-2">
                    <p className="text-indigo-300 text-sm sm:text-base">
                      <span className="font-medium">Chase Balance - </span> {card.balancePayment}
                    </p>
                    <p className="text-purple-300 text-sm sm:text-base">
                      <span className="font-medium">Chase Statement Closing - </span> {card.statementClosing}
                    </p>
                    <p className="text-indigo-300 text-sm sm:text-base">
                      Make sure you carry no or a very small balance on your statement. If you have paid your credit card in full, don't use it until after your statement closing date.
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-400 text-center sm:text-left">
              Click the button to get AI-powered recommendations for your credit cards.
            </p>
          )}
        </div>
      </main>
      <ToastContainer />
    </div>

  );
}

function StoryComponent() {
  const [cards, setCards] = React.useState([
    {
      name: "Chase",
      limit: 10000,
      balance: 2000,
      paymentDueDate: "2024-08-15",
      statementClosingDate: "2024-08-10",
    },
    {
      name: "American Express",
      limit: 15000,
      balance: 3000,
      paymentDueDate: "2024-08-20",
      statementClosingDate: "2024-08-15",
    },
  ]);

  const handleCardUpdate = (updatedCards) => {
    setCards(updatedCards);
  };

  const handleCardDelete = (updatedCards) => {
    setCards(updatedCards);
  };

  return (
    <div className="font-sans">
      <Utilization
        cards={cards}
      // onCardUpdate={handleCardUpdate}
      // onCardDelete={handleCardDelete}
      />
    </div>
  );
}

export default Utilization;